import { Side } from "../models/Common"
import { GlassOrder } from "../models/Layers"
import { IRoundedRectShape } from "../models/Rectangle"
import { ISolution } from "../models/Solution"
import { BaseComponent, IComponentInfo, IComponentLabels } from "./Base"

export class Glass extends BaseComponent {
  public constructor(
    id: number,
    solution: ISolution,
    coverLayer: GlassOrder,
    color?: string
  ) {
    super(
      {
        id,
        color: color || GlassOrderToColor(coverLayer),
        description: "",
      } as IComponentInfo,
      {
        width: solution.glass.width[coverLayer],
        height: solution.glass.height[coverLayer],
        radius: solution.customization.corners[coverLayer],
        centralOffsetX: solution.glass.centralOffsetX[coverLayer],
        centralOffsetY: solution.glass.centralOffsetY[coverLayer],
      } as IRoundedRectShape,
      {
        dimensions: {
          sides: [Side.Top, Side.Left],
          diff: false,
        },
        description: false,
      } as IComponentLabels
    )
  }
}

export function GlassOrderToColor(order: GlassOrder): string {
  if (order === GlassOrder.Front) return "#000"
  if (order === GlassOrder.Middle) return "#c0b637"
  if (order === GlassOrder.Rear) return "#0003d2"
  return "Huh?"
}
